import React from 'react';
import PropTypes from 'prop-types';

const Checkbox = props => {
  return <React.Fragment>
    {
      props.checked
        ? <i className={`cursor-pointer fas fa-check-square text-success fa-${props.size}x ${props.className}`} />
        : <i className={`cursor-pointer far fa-square fa-${props.size}x ${props.className}`} />
    }
  </React.Fragment>;
};

Checkbox.defaultProps = {
  checked: false,
  size: 2,
  className: "",
};

Checkbox.propTypes = {
  checked: PropTypes.bool.isRequired,
  size: PropTypes.number,
  className: PropTypes.string,
};

export default Checkbox;
